import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CarouselModule } from 'primeng/carousel';
import { ImageModule } from 'primeng/image';
import { PublicService } from './service.service';
import { PublicProjectComponent } from './public-project/public-project.component';
import { ButtonModule } from 'primeng/button';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from 'primeng/api';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputMaskModule } from 'primeng/inputmask';
import { InputOtpModule } from 'primeng/inputotp';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { PasswordModule } from 'primeng/password';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { TabMenuModule } from 'primeng/tabmenu';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { AppRoutingModule } from '../app-routing.module';
import { DashboardTemplateComponent } from '../module/dashboard/dashboard-template/dashboard-template.component';
import { TranslocoRootModule } from '../transloco-root.module';
import { DialogModule } from 'primeng/dialog';
import { DataViewModule } from 'primeng/dataview';
import { SkeletonModule } from 'primeng/skeleton';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { CardModule } from "src/app/module/card/card.module";
import { PublicProjectDetailsComponent } from './public-project-details/public-project-details.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { InitialPageComponent } from './initial-page/initial-page.component';
import { SharedFileComponent } from './shared-file/shared-file.component';



@NgModule({
  declarations: [
    PublicProjectComponent,
    PublicProjectDetailsComponent,
    WelcomeComponent,
    InitialPageComponent,
    SharedFileComponent
  ],
  imports: [
    CommonModule,
    ProgressSpinnerModule,
    CarouselModule,
    ImageModule,
    ButtonModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    InputTextModule,
    InputGroupModule,
    InputGroupAddonModule,
    PasswordModule,
    MessagesModule,
    MessageModule,
    ReactiveFormsModule,
    DropdownModule,
    CalendarModule,
    InputMaskModule,
    SelectButtonModule,
    TranslocoRootModule,
    HttpClientModule,
    CheckboxModule,
    InputOtpModule,
    DashboardTemplateComponent,
    TabMenuModule,
    InputSwitchModule,
    TooltipModule,
    ToastModule,
    ConfirmDialogModule,
    TableModule,
    SharedModule,
    DialogModule,
    DataViewModule,
    SkeletonModule,
    InputIconModule,
    IconFieldModule,
    CardModule
],
  providers: [
    PublicService // Registrar o serviço aqui
  ]
  
})
export class PublicModule { }
